/** @format */

export interface SkuDefiningAttribute {
  identifier: string;
  isDisplayable: boolean;
  name: string;
  seq: string | number;
  value: string;
}
